export default "__VITE_ASSET__CMqsjfYa__"